module.exports = "<div class=\"fit bg-white custom-style\">\n  <ng-content></ng-content>\n</div>\n"